import { useCallback } from 'react'

export default function useCellFilter(
    article: string,
    setFilter: (updater: any) => void,
    filterable?: boolean
) {
    const handleCellDataClick = useCallback(
        (value: string | number | boolean) => {
            if (filterable) {
                return setFilter((prevFilter: any) =>
                    Object.assign({}, prevFilter, { [article]: value })
                )
            } else {
                return
            }
        },
        [filterable, article, setFilter]
    )

    return { handleCellDataClick }
}